module.exports = __webpack_public_path__ + "img/lg_ring_r_0_0_null@2x.c753c3b5.png";